import { all, fork } from 'redux-saga/effects';

// internal
import { accountSaga } from './account';
import { brandSaga } from './brand';
import { projectSaga } from './project';
import { zoneSaga } from './zone';
import { userSaga } from './user';
import { permissionSaga } from './permission';
import { deviceSaga } from './device';

export default function* saga() {
  yield all([
    fork(accountSaga),
    fork(brandSaga),
    fork(projectSaga),
    fork(zoneSaga),
    fork(userSaga),
    fork(permissionSaga),
    fork(deviceSaga),
  ]);
}
